import { TableName, TableNameTranslations } from '@/enums/tableName';

/**
 * Nazwa encji
 *
 * @export
 * @param {string} name
 * @returns {string}
 */
export function tableName(name: TableName): string {
  return TableNameTranslations[name];
}
